import { SendPatientAccessCodeResponse } from './sendPatientAccessCodeResponse';

const mockData = {
  patientAccessCodeSent: true,
};

export const SendPatientAccessCodeServiceMock: SendPatientAccessCodeResponse = {
  data: mockData,
  succeeded: true,
};
